<template>
  <g>
    <g :transform="`rotate(-90) ${ flip ? 'translate(0 ' + (width - horizontalPadding) + ')' : ''}`">
      <g :transform="`scale(${ scale } ${ flip ? (-1* scale) : scale })`">
        <rect x=0 y=0 width=32 height=88 fill="white" />
        <path :fill="getCssColor(plugColor)" d="M938.255,377.06h-12.7c-.48,0-.961.023-1.438-.008-1.678-.105-2-.433-1.493-2.1a37.929,37.929,0,0,0,1.205-11.129,33.845,33.845,0,0,0-1.248-7.764c-.35-1.519-.081-1.965,1.4-1.993,3.194-.062,6.39,0,9.586-.022.951,0,1.262.488,1.233,1.349-.016.479,0,.958,0,1.438.043,2.239.128,2.336,2.26,2.377,1.038.021,2.077-.021,3.115.007,1.169.031,1.835-.417,1.764-1.675-.018-.319,0-.639,0-.959.034-2.522.035-2.53,2.443-2.538,2.716-.008,5.433-.039,8.149.013,1.753.034,2.133.522,1.661,2.245a33.178,33.178,0,0,0-1.283,9.2,35.805,35.805,0,0,0,1.064,8.753c.694,2.654.544,2.8-2.3,2.8Q944.965,377.07,938.255,377.06Z" transform="translate(-922.402 -315.161)"/>
        <path :fill="getCssColor(plugColor)" d="M938.555,330.043c3.439,0,6.878-.008,10.318,0,2.6.008,2.609.018,2.616,2.717.009,3.519,0,7.038,0,10.557,0,1.177-.234,2.421,1.016,3.238.343.225.493.79.094,1.028-1.512.9-1.05,2.348-1.111,3.651-.08,1.731-.073,1.769-1.749,1.8-2.079.035-4.16-.027-6.238.02-1.105.025-1.609-.364-1.575-1.52.053-1.758.03-3.519.006-5.278-.029-2.086-.155-2.266-2.127-2.259-5.877.022-4.945-.659-5,4.905-.042,4.14-.009,4.141-4.218,4.141-1.2,0-2.4-.03-3.6,0-1,.028-1.451-.383-1.448-1.409,0-1.486.314-3.062-1.3-4.093-.489-.311-.232-.9.243-1.17,1.112-.633,1.064-1.687,1.065-2.732q0-5.4,0-10.8c0-3.047-.108-2.8,2.928-2.8Q933.516,330.038,938.555,330.043Z" transform="translate(-922.402 -315.161)"/>
        <path :fill="getCssColor('schwarz')" d="M938.264,402.079c-2.075,0-4.151-.033-6.225.015a1.7,1.7,0,0,1-1.85-1.083c-1.725-3.679-3.571-7.3-5.3-10.979-.921-1.957-.347-2.885,1.807-2.895q11.733-.055,23.467,0c2.175.012,2.7.927,1.755,2.922-1.706,3.6-3.494,7.162-5.2,10.762a1.858,1.858,0,0,1-1.99,1.282C942.578,402.015,940.42,402.079,938.264,402.079Z" transform="translate(-922.402 -315.161)"/>
        <path :fill="getCssColor('schwarz')" d="M938.569,378.079c3.038,0,6.077-.016,9.116.006,1.661.012,1.68.041,1.706,1.752.024,1.679-.023,3.36.014,5.038.02.947-.393,1.232-1.3,1.228q-9.717-.039-19.432.006c-1.01.006-1.212-.443-1.2-1.295.025-1.839.039-3.679,0-5.517-.023-.937.34-1.244,1.265-1.233C932.011,378.105,935.29,378.08,938.569,378.079Z" transform="translate(-922.402 -315.161)"/>
        <path :fill="getCssColor(plugColor)" d="M940.953,351.621c0,1.674-.024,3.349.008,5.022.021,1.122-.511,1.6-1.592,1.58-.558-.011-1.117.023-1.674,0-1.722-.073-1.879-.2-1.9-1.979q-.051-4.663,0-9.327c.021-1.761.17-1.863,1.94-1.943,3.122-.142,3.216-.053,3.221,3.06q0,1.794,0,3.588Z" transform="translate(-922.402 -315.161)"/>
        <path fill="#d2d2d2" d="M944.367,322.323c0,1.748-.02,3.5.007,5.243.015.95-.276,1.481-1.345,1.5-1.1.014-1.585-.362-1.571-1.515.042-3.5.017-6.991.013-10.486,0-.953.19-1.773,1.336-1.889.977-.1,1.51.514,1.549,1.909C944.405,318.826,944.367,320.575,944.367,322.323Z" transform="translate(-922.402 -315.161)"/>
        <path fill="#d2d2d2" d="M935.272,322.309c0,1.751-.04,3.5.014,5.252.037,1.175-.515,1.509-1.593,1.5s-1.329-.579-1.324-1.514c.02-3.422,0-6.845.019-10.267a2.533,2.533,0,0,1,.255-1.139,1.452,1.452,0,0,1,1.52-.929,1.257,1.257,0,0,1,1.082,1.366c.027,1.91.01,3.82.01,5.73Z" transform="translate(-922.402 -315.161)"/>
      </g>
    </g>
  </g>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'UrmP2',
  props: {
    scale: {
      type: Number,
      default: .7
    },
    plugColor: {
      type: String,
      default: 'default'
    },
    flip: {
      type: Boolean,
      default: false
    },
    width:{
      type: Number,
      default: 88
    },
    horizontalPadding: {
      type: Number,
      default: 20
    }
  },
  computed: {
    ...mapGetters([
      'getCssColor'
    ])
  }
}

</script>

<style>

</style>